export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-aimee-0ab1ab4281f3c0006fb07279b4eeb23c.jpg";